document.addEventListener('DOMContentLoaded', () => {
  const cacheBlock = document.querySelector('.cache')
  if(cacheBlock) {
    const cacheSubmit = cacheBlock.querySelector('.cache__submit')
    const cacheClose = cacheBlock.querySelector('.cache__close')

    cacheSubmit?.addEventListener('click', (e) => {
      e.stopPropagation()
      console.log('submitCache')
      localStorage.setItem('cache', JSON.stringify(true))
      cacheBlock.classList.add('cache--close')
    })
    cacheClose?.addEventListener('click', (e) => {
      e.stopPropagation()
      console.log('closeCache')
      localStorage.setItem('cache', JSON.stringify(false))
      cacheBlock.classList.add('cache--close')
    })

    setTimeout(()=> {
      if(localStorage.getItem('cache')) return
      cacheBlock.classList.add('cache--view')
    })
  }
})